// @ts-nocheck
/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import MarkdownContent from "../components/markdownContent";
import Layout from "../components/layout";
import Seo from "../components/seo";

import styles from "./markdown-page.css";

export default function MarkdownPage({ data }) {
    const {
        html,
        frontmatter: { title, description },
    } = data.markdownRemark;

    return (
        <Layout>
            <Seo title={title} description={description} />
            <MarkdownContent className={styles.MarkdownPage}>
                <div className={styles.container}>
                    <div dangerouslySetInnerHTML={{ __html: html }} />
                </div>
            </MarkdownContent>
        </Layout>
    );
}

MarkdownPage.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.shape({
            frontmatter: PropTypes.shape({
                title: PropTypes.string.isRequired,
                description: PropTypes.string,
            }).isRequired,
            html: PropTypes.string,
        }).isRequired,
    }).isRequired,
};

export const query = graphql`
    query ($slug: String!) {
        markdownRemark(fields: { slug: { eq: $slug } }) {
            html
            frontmatter {
                title
                description
            }
        }
    }
`;
